import PropTypes from 'prop-types';
import React from 'react';
import {
  Layout,
  LayoutContainer,
  StepContainer,
  Wizard,
} from '@bingads-webui-react/wizard';
import {
  CardFooter,
  LoadingShimmer,
  BusyBlocker,
  CancelWizardDialog,
} from '@bingads-webui-react/wizard-ui-library';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { tokens } from '@fluentui/react-components';
import { CREATE_INTENT, EDIT_INTENT } from '../common/constants/intents';
import { LiftMeasurementStepFooter } from './footer/footer';
import { stepConfigs } from './config';
import { CustomLayoutTemplate } from './templates';

const getStyles = () => ({
  '@global': {
    '.default-layout': {
      '& .step-content-container': {
        padding: 0,
      },
      '& .footer-container': {
        'background-color': tokens.colorNeutralBackground1,
        bottom: 0,
        position: 'sticky',
      },
    },
  },
});

export const LiftMeasurementWizard = ({
  intent,
  onCancel,
  onSaveAndExit,
}) => {
  useDefaultStyles(getStyles);

  const config = {
    id: 'lift-measurement-wizard',
    actions: {
      onDone: () => {
        onSaveAndExit();
      },
      onExited: () => {
        onCancel();
      },
    },
    initialWizardData: {
      intent,
      selectedCampaignsById: {},
      uetTags: {
        both: [],
        conversion: [],
        visit: [],
      },
    },
    steps: stepConfigs,
  };

  return (
    <Wizard config={config}>
      <LayoutContainer template={CustomLayoutTemplate}>
        <Layout type="LoadingShimmer" component={LoadingShimmer} />
        <Layout type="StepContainer" component={StepContainer} />
        <Layout type="Footer" component={LiftMeasurementStepFooter} />
        <Layout type="CardFooter" component={CardFooter} />
        <Layout type="Blocker" component={BusyBlocker} />
        <Layout type="CancelDialog" component={CancelWizardDialog} />
      </LayoutContainer>
    </Wizard>
  );
};

LiftMeasurementWizard.propTypes = {
  intent: PropTypes.oneOf([
    CREATE_INTENT,
    EDIT_INTENT,
  ]).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
};
